import Chart from 'chart.js';

const config = {
    type: 'line',
    data: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Peak sun hours',
                data: window.pSh,
                fill: false,
                pointBorderWidth: 2,
                pointRadius: 4,
                borderWidth: 2,
                pointBackgroundColor: '#FFFFFF',
                pointBorderColor: 'rgb(220,220,220)',
                borderColor: 'rgb(220,220,220)',
            },
            {
                label: 'Daily KWh production inc losses*',
                data: window.dKwh,
                fill: false,
                pointBorderWidth: 2,
                pointRadius: 3,
                borderWidth: 2,
                pointStyle: 'rect',
                rotation: 45,
                pointBackgroundColor: '#414042',
                pointBorderColor: '#414042',
                borderColor: '#414042'
            },
            {
                label: 'Daily KWh production including losses* and shading',
                data: window.dKwhShading,
                fill: false,
                pointBorderWidth: 2,
                pointRadius: 4,
                borderWidth: 2,
                pointBackgroundColor: '#FFFFFF',
                pointBorderColor: '#ef6e0b',
                borderColor: '#ef6e0b'
            }
        ]
    },
    options: {
        responsive: true,
        hover: {
            mode: 'nearest',
            intersect: true
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            position: 'nearest'
        },
        legend: {
            display: false,
        },
        legendCallback(chart) {
            return chart.data.datasets.map(dataset => (
                `<li class="line-chart__legend-item small semi">
                    <span style="background-color:${dataset.borderColor}"></span>
                    ${dataset.label}
                </li>`
            )).join('');
        },
        scales: {
            xAxes: [{
                display: true,
                offset: true,
                gridLines: {
                    offsetGridLines: true,
                    color: '#DDDDDD',
                    zeroLineColor: '#DDDDDD',
                    borderDash: [5,5]
                },
                ticks: {
                    fontStyle: 500,
                    fontFamily: "'Gotham', 'Arial', sans-serif",
                    fontColor: "#000000",
                    padding: 5
                }
            }],
            yAxes: [{
                display: true,
                position: 'right',
                gridLines: {
                    offsetGridLines: false,
                    color: '#DDDDDD',
                    zeroLineColor: '#DDDDDD',
                },
                ticks: {
                    fontStyle: 500,
                    fontFamily: "'Gotham', 'Arial', sans-serif",
                    fontColor: "#000000",
                    padding: 20
                },
                scaleLabel: {
                    display: true,
                    labelString: 'KWh',
                    fontColor: "#000000",
                    fontStyle: 500,
                    fontFamily: "'Gotham', 'Arial', sans-serif"
                }
            }]
        },
        animation: {
            onComplete() {
                this.canvas.nextElementSibling.setAttribute('src', this.toBase64Image());
            },
        },
    }
};

export default (() => {
    const charts = Array.from(document.querySelectorAll('.js-line-chart'));

    charts.forEach((component) => {
        const canvas = component.querySelector('canvas').getContext('2d');
        const chart = new Chart(canvas, config);
        const legend = component.querySelector('.js-line-chart-legend');
        legend.innerHTML = chart.generateLegend();
    });
})();
